export type DateSegment = 'day' | 'month' | 'year';

export interface DateFormat {
  order: DateSegment[];
  separator: string;
}

const DEFAULT_ORDER: DateSegment[] = ['day', 'month', 'year'];
const YEAR_FIRST_ORDER: DateSegment[] = ['year', 'month', 'day'];
const DEFAULT_SEPARATOR = ' / ';
const SEGMENT_TOKEN: Record<DateSegment, string> = {day: 'DD', month: 'MM', year: 'YYYY'};

export const DEFAULT_DATE_FORMAT: DateFormat = {order: DEFAULT_ORDER, separator: DEFAULT_SEPARATOR};

const SEPARATOR = /\s*[/.-]\s*/;

const tokensOf = (dateFormat: string): string[] => dateFormat.split(SEPARATOR).filter(Boolean);

export const isDateTemplate = (dateFormat: string): boolean => {
  const tokens = tokensOf(dateFormat);
  return (
    tokens.length === 3 &&
    tokens.every(token => token.length === 2 || token.length === 4) &&
    tokens.filter(token => token.length === 4).length === 1
  );
};

export const parseSeparator = (dateFormat: string): string => {
  const match = dateFormat.match(SEPARATOR);
  const core = (match ? match[0] : '/').trim();
  return ` ${core} `;
};

export const parseOrder = (dateFormat: string): DateSegment[] => {
  const tokens = tokensOf(dateFormat);
  if (tokens.length < 3) return DEFAULT_ORDER;
  return tokens[0].length >= 4 ? YEAR_FIRST_ORDER : DEFAULT_ORDER;
};

export const getDateFormat = (dateFormat?: string): DateFormat =>
  dateFormat && isDateTemplate(dateFormat)
    ? {order: parseOrder(dateFormat), separator: parseSeparator(dateFormat)}
    : DEFAULT_DATE_FORMAT;

export const buildDatePlaceholder = ({order, separator}: DateFormat): string =>
  order.map(segment => SEGMENT_TOKEN[segment]).join(separator);
